import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Icon from '@salesforce/design-system-react/components/icon';
import Spinner from '@salesforce/design-system-react/components/spinner';
import EventStatusBadge from '../../Shared/EventStatusBadge';
import { getSvgIcon } from '../../../util/utilityFunctions';
import {
  INVENTORY_REQUEST_SUBMISSION_STATUS,
  INVENTORY_STATUS,
  ORDER_SCREEN_TYPE,
  ORDER_STATUS,
} from '../../../util/constants';

interface Status {
  eventStatus: string;
  visualIndicator?: string;
  parentEventStatus: string;
  status: string;
  showRedWarningIcon: boolean;
  showBackorderdWarning: boolean;
  thresholdQuantityIndicator: boolean;
  checkRejectLineStatus: boolean;
  submissionStatus?: string | null;
}
export interface Props {
  children?: FC;
  item?: Status;
  type?: string;
  isSubmissionInFlight?: boolean;
}

const OrderRequestStatusCell: FC<Props> = ({
  item = {
    eventStatus: '',
    parentEventStatus: '',
    status: '',
    visualIndicator: '',
    thresholdQuantityIndicator: false,
    showRedWarningIcon: false,
    showBackorderdWarning: false,
    checkRejectLineStatus: false,
    submissionStatus: null,
  },
  type = null,
  isSubmissionInFlight,
}) => {
  const {
    eventStatus,
    status,
    visualIndicator,
    showRedWarningIcon,
    showBackorderdWarning,
    thresholdQuantityIndicator,
    checkRejectLineStatus,
    submissionStatus,
  } = item;
  const isSubmissionInFlightByStatus =
    submissionStatus === INVENTORY_REQUEST_SUBMISSION_STATUS.QUEUED ||
    submissionStatus === INVENTORY_REQUEST_SUBMISSION_STATUS.PROCESSING;
  const shouldShowSubmissionInFlight =
    isSubmissionInFlight !== undefined ? isSubmissionInFlight : isSubmissionInFlightByStatus;
  const statusToShow =
    visualIndicator === INVENTORY_STATUS.REJECTED || visualIndicator === INVENTORY_STATUS.APPROVED
      ? eventStatus
      : visualIndicator;
  let orderStatus = statusToShow;
  let showWarningIcon = false;
  const iconBackorder = getSvgIcon('backorder');
  const iconThreshold = getSvgIcon('threshold');

  if (
    type !== ORDER_SCREEN_TYPE.PROCESSED &&
    type !== ORDER_SCREEN_TYPE.FAILED &&
    eventStatus === INVENTORY_STATUS.REQUESTED &&
    visualIndicator === INVENTORY_STATUS.REJECTED
  ) {
    showWarningIcon = true;
  }

  if (type === ORDER_SCREEN_TYPE.PROCESSED || type === ORDER_SCREEN_TYPE.FAILED) {
    orderStatus = visualIndicator === ORDER_STATUS.COMPLETED ? visualIndicator : status;
    showWarningIcon = showRedWarningIcon;
  }

  return (
    <IconSettings iconPath="/icons">
      <DataTableCell title={orderStatus || 'NEW'}>
        <div style={{ display: 'flex' }}>
          <EventStatusBadge status={orderStatus || 'NEW'} />
          {(showWarningIcon || checkRejectLineStatus) && (
            <div style={{ marginLeft: '5px' }}>
              <Icon
                title="Rejected"
                category="utility"
                name="warning"
                size="x-small"
                style={{ color: '#b83c27' }}
                className="slds-icon-text-error"
              />
            </div>
          )}
          {showBackorderdWarning && (
            <img
              src={iconBackorder}
              alt="backorder"
              style={{ width: '20px', height: '15px', marginLeft: '5px' }}
            />
          )}
          {thresholdQuantityIndicator && (
            <img
              className="slds-tooltip-trigger"
              title="Threshold Exceed"
              src={iconThreshold}
              alt="backorder"
              style={{ width: '20px', height: '15px', marginLeft: '5px' }}
            />
          )}
          {shouldShowSubmissionInFlight && (
            <div
              title="Submission processing"
              style={{ marginLeft: '5px', display: 'flex', alignItems: 'center' }}
            >
              <Spinner
                size="x-small"
                variant="base"
                assistiveText={{ label: 'Submission processing' }}
                containerStyle={{ position: 'relative', height: '1rem', width: '1rem' }}
              />
            </div>
          )}
        </div>
      </DataTableCell>
    </IconSettings>
  );
};

export default OrderRequestStatusCell;
